var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcademicIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 426.666667h640v277.333333H192z",
    fill: "#37474F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 704a320 128 0 1 0 640 0 320 128 0 1 0-640 0Z",
    fill: "#37474F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M492.8 174.933333L12.8 386.133333c-17.066667 8.533333-17.066667 32 0 40.533334l480 211.2c12.8 4.266667 25.6 4.266667 38.4 0L1011.2 426.666667c17.066667-8.533333 17.066667-32 0-40.533334L531.2 174.933333c-12.8-6.4-25.6-6.4-38.4 0z",
    fill: "#78909C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M921.6 435.2l-426.666667-72.533333c-10.666667-2.133333-23.466667 6.4-25.6 17.066666-2.133333 10.666667 6.4 23.466667 17.066667 25.6L896 473.6V789.333333c0 12.8 8.533333 21.333333 21.333333 21.333334s21.333333-8.533333 21.333334-21.333334V456.533333c0-10.666667-8.533333-19.2-17.066667-21.333333z",
    fill: "#37474F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M917.333333 789.333333m-42.666666 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z",
    fill: "#37474F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M981.333333 853.333333c0 36.266667-64 128-64 128s-64-91.733333-64-128 27.733333-64 64-64 64 27.733333 64 64z",
    fill: "#37474F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicIcon);
export default __webpack_public_path__ + "static/media/academic-icon.ab7408a6450ac103c09d103998484199.svg";
export { ForwardRef as ReactComponent };